import { useEffect, useState } from 'react';
import { cn } from '../lib/utils';
import { MaintenanceTab } from './MaintenanceTab';
import { MaintenanceDrippingTab } from './MaintenanceDrippingTab';

/**
 * Maintenance area with Items + Dripping settings sub-tabs.
 */
export function MaintenanceArea({ focusItemId = null }) {
  const [subTab, setSubTab] = useState('items');

  useEffect(() => {
    if (focusItemId) setSubTab('items');
  }, [focusItemId]);

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="shrink-0 border-b border-gray-200 bg-white px-3 pt-2 sm:px-4">
        <div className="inline-flex rounded-lg bg-gray-100 p-0.5">
          <button
            type="button"
            onClick={() => setSubTab('items')}
            className={cn(
              'rounded-md px-3 py-1.5 text-xs font-medium transition-colors',
              subTab === 'items'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-900',
            )}
            data-testid="maintenance-subtab-items"
          >
            Items
          </button>
          <button
            type="button"
            onClick={() => setSubTab('dripping')}
            className={cn(
              'rounded-md px-3 py-1.5 text-xs font-medium transition-colors',
              subTab === 'dripping'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-900',
            )}
            data-testid="maintenance-subtab-dripping"
          >
            Dripping
          </button>
        </div>
      </div>
      {subTab === 'items' ? (
        <MaintenanceTab focusItemId={focusItemId} />
      ) : (
        <div className="min-h-0 flex-1 overflow-y-auto bg-gray-50/40 p-4 sm:p-6">
          <MaintenanceDrippingTab />
        </div>
      )}
    </div>
  );
}
